module.exports = __webpack_public_path__ + "static/blurred_guy-08d421a09af5d689ac6e6383c0291302.png";